import { combineReducers } from 'redux';

import CDFTypes from './types';

export enum enFiscalDocumentsActions {
  details = 'CDF/FISCAL_DOCUMENTS_DETAILS',
  detailsItemRequest = 'CDF/FISCAL_DOCUMENTS_DETAILS_ITEMS_REQUEST',
  detailsItemSuccess = 'CDF/FISCAL_DOCUMENTS_DETAILS_ITEMS_SUCCESS',
  detailsItemError = 'CDF/FISCAL_DOCUMENTS_DETAILS_ITEMS_ERROR',
  detailsFilesRequest = 'CDF/FISCAL_DOCUMENTS_DETAILS_FILES_REQUEST',
  detailsFilesSuccess = 'CDF/FISCAL_DOCUMENTS_DETAILS_FILES_SUCCESS',
  detailsFilesError = 'CDF/FISCAL_DOCUMENTS_DETAILS_FILES_ERROR',
}

const initialState = { isFetching: false };

export const details = (state: any = initialState, action: any) => {
  switch (action.type) {
    case enFiscalDocumentsActions.details:
      return { ...state, data: action.data, items: null, files: null };

    //Items
    case enFiscalDocumentsActions.detailsItemRequest:
      if (!state.data) return state;
      return { ...state, isItemsFetching: true, error: null as any, items: null as any };
    case enFiscalDocumentsActions.detailsItemSuccess:
      if (!state.data) return state;
      return { ...state, isItemsFetching: false, items: action.data };
    case enFiscalDocumentsActions.detailsItemError:
      if (!state.data) return state;
      return { ...state, isItemsFetching: false, error: action.error };

    //Files
    case enFiscalDocumentsActions.detailsFilesRequest:
      if (!state.data) return state;
      return { ...state, isFilesFetching: true, error: null as any, files: null as any };
    case enFiscalDocumentsActions.detailsFilesSuccess:
      if (!state.data) return state;
      return { ...state, isFilesFetching: false, files: action.data };
    case enFiscalDocumentsActions.detailsFilesError:
      if (!state.data) return state;
      return { ...state, isFilesFetching: false, error: action.error };

    default:
      return state;
  }
};

export const reducer = combineReducers({
  list: CDFTypes.list.getReducer(),
  details,
  urlDownload: CDFTypes.urlDownload.getReducer(),
  export: CDFTypes.export.getReducer(),
});
